function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("title", null, "delete");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "delete",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "delet"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 20,
  height: 20,
  rx: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.75,5 L15,6.25 L11.25,10 L15,13.75 L13.75,15 L10,11.25 L6.25,15 L5,13.75 L8.75,10 L5,6.25 L6.25,5 L10,8.75 L13.75,5 Z",
  id: "Combined-Shape",
  fill: "currentColor"
})));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/delete.57ae9e87.svg";
export { SvgComponent as ReactComponent };